import React from 'react';
import { observer } from 'mobx-react';
import { routeNode } from 'core/routing';
import { FourOhFour } from 'apps/fourOhFour/index';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';
import { DiscoverStories } from 'apps/home/discover/stories/index';

const viewsMap = {
  stories: DiscoverStories,
  // guides: DicoverGuides,
  // help: DicoverHelp,
};

@withNamespaces()
@observer
class DiscoverSpace extends React.Component {
  UNSAFE_componentWillMount() {
    const { route, routerStore } = this.props;
    if (route.name === 'home.discover') {
      routerStore.router.navigate('home.discover.topics');
    }
  }

  render() {
    const View = this.props.componentFromRoute();
    return <View params={this.props.route.params} />;
  }
}

DiscoverSpace.propTypes = {
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

export const DiscoverRouter = routeNode(
  'home.discover',
  viewsMap,
  FourOhFour,
)(DiscoverSpace);
